import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
  Typography,
} from "@mui/material";

const AcademicYearForm = ({
  initialData,
  onSubmit,
  onCancel,
  buttonLoading,
}) => {
  const [form, setForm] = useState({
    name: "",
    startDate: "",
    endDate: "",
    isCurrent: false,
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (initialData) {
      setForm(initialData);
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const validate = () => {
    let temp = {};

    if (!form.name) temp.name = "Academic year is required";
    if (!form.startDate) temp.startDate = "Start date is required";
    if (!form.endDate) temp.endDate = "End date is required";

    if (form.startDate && form.endDate) {
      if (new Date(form.endDate) <= new Date(form.startDate)) {
        temp.endDate = "End date must be after start date";
      }
    }

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const payload = { ...form };

    onSubmit(payload);
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Typography
        variant="h6"
        fontWeight={600}
        color="text.secondary"
        mb={2}
        textAlign="center"
      >
        {initialData ? "Edit Academic Year" : "Create Academic Year"}
      </Typography>

      <Box display="flex" flexDirection="column" gap={2}>
        <TextField
          label="Academic Year"
          name="name"
          placeholder="2025-2026"
          value={form.name}
          onChange={handleChange}
          size="small"
          fullWidth
          error={!!errors.name}
          helperText={errors.name}
          required
        />

        <Box display="flex" gap={2}>
          <TextField
            label="Start Date"
            name="startDate"
            type="date"
            value={form?.startDate ? form?.startDate?.split("T")[0] : ""}
            onChange={handleChange}
            size="small"
            fullWidth
            error={!!errors.startDate}
            helperText={errors.startDate}
            required
            slotProps={{
              inputLabel: { shrink: true },
            }}
          />

          <TextField
            label="End Date"
            name="endDate"
            type="date"
            value={form?.endDate ? form?.endDate?.split("T")[0] : ""}
            onChange={handleChange}
            size="small"
            fullWidth
            error={!!errors.endDate}
            required
            helperText={errors.endDate}
            slotProps={{
              inputLabel: { shrink: true },
            }}
          />
        </Box>

        <FormControlLabel
          control={
            <Checkbox
              name="isCurrent"
              checked={form.isCurrent}
              onChange={handleChange}
            />
          }
          label="Set as current academic year"
        />
      </Box>

      <Box mt={3} display="flex" justifyContent="flex-end" gap={1.5}>
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
          }}
        >
          Cancel
        </Button>

        <Button
          type="submit"
          variant="contained"
          loading={buttonLoading}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            backgroundColor: "rgb(35, 71, 159)",
          }}
        >
          {initialData ? "Update" : "Create"}
        </Button>
      </Box>
    </Box>
  );
};

export default AcademicYearForm;
